module.exports = __webpack_public_path__ + "img/14_26.9b4925ad.png";